import { Middleware } from 'redux';
import orb1Actions, {
    EORB1Actions,
    EORB1Constants,
    TORB1Actions,
} from '../actions';
import { TORB1BackendRecord } from '../@types';
import { IStore } from 'redux/store';
import { IAuthActions } from '../../auth/actions';
import { jobActions } from 'redux/_core/job';
import { apiActions } from 'redux/_core/api';
import { commonUtils } from 'redux/_common';
import { EMARPOLDocuments, EMARPOLModelName } from 'redux/app/marpol/@types';

const orb1HistoryMiddleware: Middleware<{}, IStore> =
    ({ dispatch, getState }) =>
    (next) =>
    (action: TORB1Actions | IAuthActions) => {
        switch (action.type) {
            case EORB1Actions.HISTORY_LOAD: {
                next(action);
                const job = jobActions(EORB1Constants.FEATURE, action.type);
                const { providedFilters: filters } = action.payload;
                dispatch(orb1Actions.document.setFilter(filters));
                dispatch(
                    apiActions.apiRequest<{ logs: { docs: TORB1BackendRecord[] } }>({
                        feature: action.type,
                        method: 'GET',
						url: EORB1Constants.API,
                        queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.ORB1,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined
							},
							sortOrder: filters?.sortOrder ?? undefined,
                        },
                        preExecute() {
                            dispatch(job.active({}));
                        },
                        postExecute: {
                            onSuccess({ data }) {
								const orb1Records = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.ORB1
								);
                                dispatch(
                                    orb1Actions.document.historySet(
										commonUtils.arrayToObject(orb1Records)
                                    )
                                );
                                dispatch(job.success({}));
                            },
                            onError() {
                                dispatch(job.error({}));
                            },
                            finally() {
                                dispatch(job.idle({}));
                            },
                        },
                    })
                );
                break;
            }
            default: {
                next(action);
                break;
            }
        }
    };
export default orb1HistoryMiddleware;
